import React, {
    useCallback, useContext, useMemo
} from 'react';
import { TranslatorContext } from '@jutro/locale';
import { Link } from '@jutro/components';
import { SgWebchatUtil } from 'saga-modules';
import messages from './SgWebchatInfo.messages';

function SgWebchatInfo(props) {
    const {
        showMtaMessage
    } = props;

    const translator = useContext(TranslatorContext);

    const trackChat = useCallback((event) => {
        if (event) {
            event.preventDefault();
        }
        SgWebchatUtil.trackChat();
    }, []);

    const needChangeContent = useMemo(() => {
        return (
            <div className="sgWebChatLinkContainer">
                <h4 className="sgWebChatHeader">
                    {!showMtaMessage ? translator(messages.NeedChangeHeader) : translator(messages.NeedChangeMtaHeader)}
                </h4>
                <p className="sgWebChatText">
                    {!showMtaMessage ? translator(messages.NeedChangeMessage) : translator(messages.NeedChangeMtaMessage)}
                    {' '}
                    <Link href="/" className="sgWebchatLink saga-intercom" onClick={trackChat} aria-hidden="true">
                        {translator(messages.WebchatText)}
                    </Link>
                </p>
            </div>
        );
    }, [showMtaMessage, translator]);

    return (
        <div>
            { needChangeContent }
        </div>
    );
}
export default SgWebchatInfo;
